import { RootState } from 'src/store';

import { IPayoutLimit } from '../payoutLimits/types';

export const selectPaymentLimitsData = (state: RootState): IPayoutLimit[] => state.paymentLimits.data;
export const selectPaymentLimitsLoading = (state: RootState): boolean => state.paymentLimits.isLoading;
export const selectPaymentLimitsLoaded = (state: RootState): boolean => state.paymentLimits.isLoaded;
